import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort", event.target.value);
    Turbo.visit(url);
  }
}
